module.exports = __webpack_public_path__ + "img/map-step_1.9e88bd2.webp";